import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import unsplash from '../../api/unsplash';
import { getTokenFromLocalStorage } from '../../utils/localStorageHelpers';
import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarQuickFilter,
    itIT,
} from '@mui/x-data-grid-pro';
import {
    Box,
    IconButton,
    Grid,
    LinearProgress,
    Skeleton,
    Typography,
} from '@mui/material';
import { Place, Visibility } from '@mui/icons-material';

import moment from 'moment';
import { CustomFooterPersonalized } from '../../utils/CustomFooterPersonalized';

import { ContainerList } from '../AccessoLavoratore/ContainerList';

const DetailVisiteComponent = ({ el }) => {
    const navigate = useNavigate();
    return (
        <IconButton
            aria-label="edit"
            onClick={() =>
                navigate('/AreaMedico/DettaglioVisitaMedico', {
                    state: { visita: el },
                })
            }
        >
            <Visibility
                style={{ height: '2rem', width: '2rem', color: '#11526F' }}
            />
        </IconButton>
    );
};

const VisiteMedici = (props) => {
    const [visiteStorico, setVisiteStorico] = useState([]);
    const [visiteFuture, setVisiteFuture] = useState([]);
    const [visiteBackup, setVisiteBackup] = useState([]);

    const [loading, setLoading] = useState(true);
    const dal = moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD');
    const al = moment(new Date()).format('YYYY-MM-DD');

    const splitVisite = (items) => {
        const today = moment(new Date()).format('YYYYMMDD');
        const storico = [];
        const future = [];

        items.forEach((el) => {
            const day = moment(el.DataWithoutTime).format('YYYYMMDD');
            if (day <= today) {
                storico.push(el);
            } else {
                future.push(el);
            }
        });

        setVisiteStorico(storico);
        setVisiteFuture(future);
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                    padding={2}
                    columnGap={2}
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }
    const columns = [
        {
            filterable: false,
            field: 'Actions',
            headerName: 'Azioni',
            hide: false,
            align: 'center',
            headerAlign: 'center',
            width: '100',
            renderCell: (
                params //mi aiuta a mettere il valore
            ) => <DetailVisiteComponent el={params.row} />,
        },
        {
            field: 'DataWithoutTime',
            headerName: 'Data',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) =>
                params.row.DataWithoutTime
                    ? moment(params.row.DataWithoutTime).format('DD/MM/YYYY')
                    : '',
        },
        {
            field: 'Luogo',
            headerName: 'Luogo',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Lavoratori',
            headerName: 'N° Lavoratori',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                let respData = await unsplash.post(
                    'portaleMedici',
                    {
                        operation: 'GetAll',
                        medico: sessionStorage.getItem('Medico'),
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                        },
                    }
                );

                setVisiteBackup(respData.data.visite);
                splitVisite(respData.data.visite);
            } catch {
                setVisiteStorico([]);
                setVisiteFuture([]);
                setVisiteBackup([]);
            }
            setLoading(false);
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (visiteBackup.length === 0) return;

        const inRange = visiteBackup.filter(
            (el) =>
                moment(el.DataWithoutTime).format('YYYY-MM-DD') >=
                    moment(dal).format('YYYY-MM-DD') &&
                moment(el.DataWithoutTime).format('YYYY-MM-DD') <=
                    moment(al).format('YYYY-MM-DD')
        );
        splitVisite(inRange);
    }, [dal, al, visiteBackup]);

    return (
        <>
            <div className="lg:hidden">
                {!loading ? (
                    <>
                        <Typography
                            sx={{
                                mb: 1.5,
                                fontSize: 16,
                                fontWeight: 600,
                                fontFamily: 'Poppins, Roboto, sans-serif',
                                color: '#5b5b5b',
                            }}
                        >
                            Future visite in programma
                        </Typography>
                        <ContainerList
                            data={visiteFuture.map((visita) => {
                                return {
                                    ...visita,
                                    DataFilter: moment(
                                        visita.DataWithoutTime
                                    ).format('DD/MM/YYYY'),
                                };
                            })}
                            header={['Giorno', 'Visita']}
                            leftCard={['DataFilter']}
                            additionalFilter={['DataFilter']}
                            rightCard={[
                                { title: true, prop: 'Lavoratori' },
                                {
                                    prop: 'Luogo',
                                    icon: <Place fontSize="12" />,
                                },
                            ]}
                            titleCard="Lavoratori: "
                            component={<DetailVisiteComponent />}
                        />

                        <Box sx={{ mt: 7 }}>
                            <Typography
                                sx={{
                                    mb: 1.5,
                                    fontSize: 16,
                                    fontWeight: 600,
                                    fontFamily: 'Poppins, Roboto, sans-serif',
                                    color: '#5b5b5b',
                                }}
                            >
                                Storico visite effettuate
                            </Typography>
                        </Box>
                        <ContainerList
                            data={visiteStorico.map((visita) => {
                                return {
                                    ...visita,
                                    DataFilter: moment(
                                        visita.DataWithoutTime
                                    ).format('DD/MM/YYYY'),
                                };
                            })}
                            header={['Giorno', 'Visita']}
                            leftCard={['DataFilter']}
                            additionalFilter={['DataFilter']}
                            rightCard={[
                                { title: true, prop: 'Lavoratori' },
                                {
                                    prop: 'Luogo',
                                    icon: <Place fontSize="12" />,
                                },
                            ]}
                            titleCard="Lavoratori: "
                            component={<DetailVisiteComponent />}
                        />
                    </>
                ) : (
                    <div className="flex flex-wrap">
                        <div className="flex w-full gap-x-2">
                            <Skeleton
                                variant="rounded"
                                width="20%"
                                height={50}
                            />
                            <Skeleton
                                variant="rectangular"
                                width="4px"
                                height={60}
                            />
                            <Skeleton
                                variant="rounded"
                                width="80%"
                                height={50}
                            />
                        </div>
                        <div className="flex w-full gap-x-2">
                            <Skeleton
                                variant="rounded"
                                width="20%"
                                height={50}
                            />
                            <Skeleton
                                variant="rectangular"
                                width="4px"
                                height={60}
                            />
                            <Skeleton
                                variant="rounded"
                                width="80%"
                                height={50}
                            />
                        </div>
                        <div className="flex w-full gap-x-2">
                            <Skeleton
                                variant="rounded"
                                width="20%"
                                height={50}
                            />
                            <Skeleton
                                variant="rectangular"
                                width="4px"
                                height={60}
                            />
                            <Skeleton
                                variant="rounded"
                                width="80%"
                                height={50}
                            />
                        </div>
                        <div className="flex w-full gap-x-2">
                            <Skeleton
                                variant="rounded"
                                width="20%"
                                height={50}
                            />
                            <Skeleton
                                variant="rectangular"
                                width="4px"
                                height={60}
                            />
                            <Skeleton
                                variant="rounded"
                                width="80%"
                                height={50}
                            />
                        </div>
                        <div className="flex w-full gap-x-2">
                            <Skeleton
                                variant="rounded"
                                width="20%"
                                height={50}
                            />
                            <Skeleton
                                variant="rectangular"
                                width="4px"
                                height={60}
                            />
                            <Skeleton
                                variant="rounded"
                                width="80%"
                                height={50}
                            />
                        </div>
                        <div className="flex w-full gap-x-2">
                            <Skeleton
                                variant="rounded"
                                width="20%"
                                height={50}
                            />
                            <Skeleton
                                variant="rectangular"
                                width="4px"
                                height={60}
                            />
                            <Skeleton
                                variant="rounded"
                                width="80%"
                                height={50}
                            />
                        </div>
                        <div className="flex w-full gap-x-2">
                            <Skeleton
                                variant="rounded"
                                width="20%"
                                height={50}
                            />
                            <Skeleton
                                variant="rectangular"
                                width="4px"
                                height={60}
                            />
                            <Skeleton
                                variant="rounded"
                                width="80%"
                                height={50}
                            />
                        </div>
                    </div>
                )}
            </div>
            <>
                <div className="h-[38vh] md:h-[40vh] w-full lg:block hidden">
                    <Typography
                        sx={{
                            mb: 1,
                            fontSize: 16,
                            fontWeight: 600,
                            fontFamily: 'Poppins, Roboto, sans-serif',
                            color: '#5b5b5b',
                        }}
                    >
                        Future visite in programma
                    </Typography>
                    <DataGridPro
                        components={{
                            Toolbar: CustomToolbar,
                            Footer: CustomFooterPersonalized,
                        }}
                        slots={{
                            loadingOverlay: LinearProgress,
                        }}
                        loading={loading}
                        sx={{ fontSize: 12 }}
                        localeText={
                            itIT.components.MuiDataGrid.defaultProps.localeText
                        }
                        rows={visiteFuture}
                        columns={columns}
                        getRowId={(row) => row.ID}
                        pageSize={100}
                        disableSelectionOnClick
                    />
                </div>
                <div className="h-[38vh] md:h-[40vh] w-full lg:block hidden mt-10">
                    <Typography
                        sx={{
                            mb: 1,
                            fontSize: 16,
                            fontWeight: 600,
                            fontFamily: 'Poppins, Roboto, sans-serif',
                            color: '#5b5b5b',
                        }}
                    >
                        Storico visite effettuate
                    </Typography>
                    <DataGridPro
                        components={{
                            Toolbar: CustomToolbar,
                            Footer: CustomFooterPersonalized,
                        }}
                        slots={{
                            loadingOverlay: LinearProgress,
                        }}
                        loading={loading}
                        sx={{ fontSize: 12 }}
                        localeText={
                            itIT.components.MuiDataGrid.defaultProps.localeText
                        }
                        rows={visiteStorico}
                        columns={columns}
                        getRowId={(row) => row.ID}
                        pageSize={100}
                        disableSelectionOnClick
                    />
                </div>
            </>
        </>
    );
};

export default VisiteMedici;
